import React from 'react';
import { KPIDashboard } from '../components/manager/KPIDashboard';
import { Leaderboard } from '../components/admin/Leaderboard';
import { ManagerHierarchy } from '../components/admin/ManagerHierarchy';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { useData } from '../context/DataContext';
import { exportReviewsToCsv } from '../utils/exportReport';
export function RvpView() {
  const {
    loanOfficers,
    managers,
    rvps,
    selectedWeek
  } = useData();
  // Simulate logged-in RVP (Joseph Dalal)
  const currentRvpId = 'r1';
  const currentRvp = rvps.find(r => r.id === currentRvpId);
  // Filter LOs to just this RVP's region
  const rvpManagers = managers.filter(m => m.rvpId === currentRvpId);
  const rvpLos = loanOfficers.filter(lo => rvpManagers.some(m => m.id === lo.managerId));
  const handleExport = () => exportReviewsToCsv(rvpLos, managers, selectedWeek, 'regional-accountability-report');
  const healthyCount = rvpLos.filter(lo => lo.healthIndicator === 'Healthy').length;
  const atRiskCount = rvpLos.filter(lo => lo.healthIndicator === 'At Risk').length;
  const criticalCount = rvpLos.filter(lo => lo.healthIndicator === 'Critical').length;
  const total = rvpLos.length;
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-364">
      <div className="mb-8 flex flex-col md:flex-row md:items-center justify-between" data-id="element-365">
        <div data-id="element-366">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-367">
            Regional Command Center
          </h1>
          <p className="text-slate-500 mt-1" data-id="element-368">
            {currentRvp?.region || 'Regional'} accountability and coaching
            oversight.
          </p>
        </div>
        <div className="mt-4 md:mt-0 flex space-x-3" data-id="element-369">
          <button onClick={handleExport} className="px-4 py-2 bg-white border border-slate-200 text-slate-700 rounded-lg text-sm font-medium hover:bg-slate-50" data-id="element-370">
            Export Region Report
          </button>
        </div>
      </div>

      {/* Region-wide KPIs */}
      <KPIDashboard rvpId={currentRvpId} data-id="element-371" />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8" data-id="element-372">
        <Leaderboard rvpId={currentRvpId} data-id="element-373" />

        <Card data-id="element-374">
          <CardHeader data-id="element-375">
            <CardTitle data-id="element-376">Region Coaching Health</CardTitle>
          </CardHeader>
          <CardContent data-id="element-377">
            <div className="space-y-3" data-id="element-378">
              {[{
              key: 'Healthy',
              count: healthyCount,
              bar: 'bg-emerald-500'
            }, {
              key: 'At Risk',
              count: atRiskCount,
              bar: 'bg-amber-500'
            }, {
              key: 'Critical',
              count: criticalCount,
              bar: 'bg-rose-500'
            }].map(band => <div key={band.key} className="w-full text-left rounded-lg p-2 -m-2" data-id="element-379">
                  <div className="flex justify-between text-sm mb-1" data-id="element-380">
                    <span className="font-medium text-slate-700" data-id="element-381">
                      {band.key}
                    </span>
                    <span className="text-slate-500" data-id="element-382">
                      {band.count}/{total}
                    </span>
                  </div>
                  <div className="w-full bg-slate-100 rounded-full h-2.5" data-id="element-383">
                    <div className={`${band.bar} h-2.5 rounded-full`} style={{
                  width: `${total > 0 ? band.count / total * 100 : 0}%`
                }} data-id="element-384"></div>
                  </div>
                </div>)}
            </div>
            <div className="mt-8 p-4 bg-slate-50 rounded-lg border border-slate-100" data-id="element-385">
              <h4 className="text-sm font-semibold text-slate-900 mb-2" data-id="element-386">
                Top Coaching Gap
              </h4>
              <p className="text-sm text-slate-600" data-id="element-387">
                Region-wide,{' '}
                <span className="font-bold text-slate-900" data-id="element-388">Game Films</span> has
                the lowest completion rate (48%).
              </p>
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="mt-8" data-id="element-389">
        <h2 className="text-lg font-semibold text-slate-900 mb-4" data-id="element-390">
          Managers & Reviews
        </h2>
        <ManagerHierarchy rvpId={currentRvpId} data-id="element-391" />
      </div>
    </div>;
}